
import { useEffect, useRef, useState } from 'react';

import useAxios from 'library/axios'; 
import  {IAdvanceOnSalary, IAdvanceOnSalarySearch} from '../models/AdvanceOnSalary';
import { HeadCell, RowCheckedMode } from 'components/ui/EnhancedTable';

import { useTranslation  } from 'react-i18next';
import { IPagination, ITextFilterElement } from 'components/ui/BasicTextFilterForm';


import IEnumeration, { Enum_ADVANCE_ON_SALARY_TYPE, Enum_OPERATION_STATUS, IEnumerationItem} from 'features/configuration/models/Enumeration';
import useEnumerationService from 'features/configuration/services/Enumeration';
import { useQuery } from 'react-query';
import { addMonths } from 'date-fns';
import { currentUserSessionAtom } from 'library/store';
import { useRecoilValue } from 'recoil';


const _ = () => {

    const axios = useAxios();    

    const createAdvanceOnSalary = async (advanceOnSalary: IAdvanceOnSalary)  =>       
        await (await axios.post('/api/production/advanceOnSalary/create', advanceOnSalary)).data;

    const updateAdvanceOnSalary = async (advanceOnSalary: IAdvanceOnSalary)  =>       
        await (await axios.post('/api/production/advanceOnSalary/update', advanceOnSalary)).data;

    const getAdvanceOnSalary = async (advanceOnSalaryId  : number )  => {        
        const {data} = (await axios.get(`/api/production/advanceOnSalary/getAdvanceOnSalary/${advanceOnSalaryId}`));
        return await data;
      }

    const getAdvanceOnSalarys = async (criteria  : IAdvanceOnSalarySearch, pagination?: IPagination)  => {
        const { advanceType, name,description, dateFrom, dateTo} = criteria;

        const pageSize = pagination?.pageSize ?? 50;
        const pageNumber = pagination?.pageNumber ?? 1;

        const sDateFrom = encodeURIComponent(dateFrom.toISOString().split('T')[0]);
        const sDateTo = encodeURIComponent(dateTo.toISOString().split('T')[0]);

        const {data} = (await axios.get(`api/production/advanceOnSalary/get-advanceOnSalarys?advanceType=${advanceType}&name=${name}&description=${description}&sDateFrom=${sDateFrom}&sDateTo=${sDateTo}&pageSize=${pageSize}&pageNumber=${pageNumber}`));
        return await data;
      }

    

      
    return {    
        createAdvanceOnSalary,    
        updateAdvanceOnSalary,    
        getAdvanceOnSalary,

        getAdvanceOnSalarys,
      
    } 
}

export default _;


export interface IFilterAdvanceOnSalaryOption {
    rowCheckedMode: RowCheckedMode,
    stateSelected?: [string[], React.Dispatch<React.SetStateAction<string[]>>],
    stateFiltered?: [IAdvanceOnSalary[], React.Dispatch<React.SetStateAction<IAdvanceOnSalary[]>>],
  }
  
  const defaultFilterAdvanceOnSalaryOption: IFilterAdvanceOnSalaryOption = {
    rowCheckedMode: 'single'
    //stateSelected: navigate
  }
  
  
  export const useBasicFilterAdvanceOnSalary = (  onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IAdvanceOnSalary) => void,
                                              filterOption?: IFilterAdvanceOnSalaryOption  ) => {
  
    const { getAdvanceOnSalarys } = _();

    const {getEnumerationItemsByEnumerationCodes, getAsOptions } = useEnumerationService();
  
    const { t, i18n } = useTranslation();   

    const {language: lg } = useRecoilValue(currentUserSessionAtom);

    const {rowCheckedMode, stateSelected, stateFiltered} = filterOption || defaultFilterAdvanceOnSalaryOption;
  
    const {data: enumItems, refetch: refetchEnumerationItems} = useQuery<IEnumerationItem[]>(
      ['EnumerationItems', 'AdvanceOnSalary', 'Service'], 
        () => getEnumerationItemsByEnumerationCodes( [ Enum_ADVANCE_ON_SALARY_TYPE, Enum_OPERATION_STATUS ] ));   
  
      const getAdvanceTypeList = (row: IAdvanceOnSalary, cellId: keyof IAdvanceOnSalary, 
        opts: {value: string, name: string}[]) => {
        return getAsOptions(refEnumItems.current ?? [],Enum_ADVANCE_ON_SALARY_TYPE);
      }

      const getStatusList = (row: IAdvanceOnSalary, cellId: keyof IAdvanceOnSalary, 
        opts: {value: string, name: string}[]) => {
        return getAsOptions(refEnumItems.current ?? [],Enum_OPERATION_STATUS);
      }
    

    const [headAdvanceOnSalaryCells, setHeadAdvanceOnSalaryCells]  = useState<HeadCell<IAdvanceOnSalary>[]>([
      {id:'id', label : t('Id'),  display: true, type: 'numeric', },
      {id:'advanceType', label : t('Advance type'),  display: true, type: 'string', getOptions: getAdvanceTypeList },     

      {id:'personFullNameFR', label : t('Name'),  display: lg.includes('fr'), type: 'string', },
      {id:'personFullNameEN', label : t('Name'),  display: lg.includes('en'), type: 'string', },

      {id:'description', label : t('Description'),  display: true, type: 'string', },    

      {id:'status', label : t('Status'),  display: true, type: 'string', getOptions: getStatusList },    
    ]); 

    const [filterElements,] = useState<ITextFilterElement[]>( [
      
        {name: 'dateFrom', text: t('Start date'), dataType: 'date' ,  value: '', dateValue: addMonths(new Date(), -1)},
        {name: 'dateTo', text: t('End date'), dataType: 'date'  , value: '', dateValue: new Date()},

        {name: 'advanceType', text: t('Advance type'), value: '', dataType: 'enumeration', 
              options: [...getAsOptions(enumItems, Enum_ADVANCE_ON_SALARY_TYPE)] },
        {name: 'name', text: t('Name'), value: ''},
        {name: 'description', text: t('Description'), value: ''},
       
      ]);    
  
    const [filteredAdvanceOnSalarys, ] = useState<IAdvanceOnSalary[]>([]); 
  
    const onFilterButtonClick = async (filterElements: ITextFilterElement[], pagination?: IPagination) : Promise<IAdvanceOnSalary[]> => {
     
      const dateFrom = filterElements.find( elt => elt.name === 'dateFrom')?.dateValue || new Date();
      const dateTo = filterElements.find( elt => elt.name === 'dateTo')?.dateValue || new Date();

      const advanceType = filterElements.find( elt => elt.name === 'advanceType')?.value || '';
      const name = filterElements.find( elt => elt.name === 'name')?.value || '';
      const description = filterElements.find( elt => elt.name === 'description')?.value || '';
      
  
      const arr = await getAdvanceOnSalarys( {dateFrom, dateTo, advanceType, name,description}, pagination );
      
      return arr;
    }
  
    const objKey: keyof IAdvanceOnSalary = 'id';

    const refEnumItems = useRef<IEnumerationItem[]>();
    useEffect( () => {
      refEnumItems.current = enumItems;
    }, [enumItems])
  
    return {
      title: `${t('Advance on salary')}(s)`, headCells: headAdvanceOnSalaryCells, objKey,
      filterElements, rows: filteredAdvanceOnSalarys, 
      onFilterButtonClick, onRowDoubleClick, rowCheckedMode, stateSelected, stateFiltered
    }
  }